module.exports = __webpack_public_path__ + "img/VECINA.5f18e6db.png";